// extracted by mini-css-extract-plugin
export default {"container":"SuccessDefault_container__w6Sod","content":"SuccessDefault_content__ArXOc"};